/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeStaffExportCtrl
 */
angular.module('mercury.modules.time.staff')
.controller('TimeStaffExportCtrl', ["$filter", "$scope", "TimeStaff", function($filter, $scope, TimeStaff) {
  //Should staff who have already been exported, be included in the options.
  $scope.includeExported = false;

  // Reset the export checkboxes
  angular.forEach($scope.staff, function(member) {
    member.toExport = false;
  });

  /**
   * Click event for the 'Confirm' button.
   */
  $scope.exportStaff = function() {
    var exportStaff = $filter('filter')($scope.staff, {toExport: true});

    var exportStaffIds = [];
    angular.forEach(exportStaff, function(member) {
      exportStaffIds.push(member.id);
    });

    $scope.exporting = TimeStaff.exportStaff(exportStaffIds);
    $scope.exporting.then(function() {
      angular.forEach($scope.staff, function(member) {
        if (exportStaffIds.indexOf(member.id) !== -1) {
          member.isExported = true;
        }
      });

      $scope.$close();
    });
  };

  $scope.isShown = function(member) {
    return member.datestampDeleted === null && member.isExported == $scope.includeExported;
  };

  $scope.exportableStaff = function() {
    return $filter('filter')($scope.staff, $scope.isShown).length;
  };

  $scope.validExport = function() {
    var invalidStaff = $filter('filter')($scope.staff, function(member) {
      return member.toExport && !member.payCode;
    });

    return invalidStaff.length === 0;
  };

  $scope.exportCount = function() {
    return $filter('filter')($scope.staff, {toExport: true}).length;
  };

  $scope.staffPaycodeSave = function(member) {
    TimeStaff.updatePaycode(member.id, member.payCode);
  };
}]);
